import * as React from 'react';
import styles from "./CharterNotes.module.scss";
import { GoAContainer } from '@abgov/react-components';
import { INotesDetails } from '../../model/INotesDetails';
import { formatDateString } from '../../utils/dateHandler';
import { FunctionComponent } from 'react';



interface INotesDetailssProps {
  hiringDetailsId: number | undefined;
  NotesDetailsList: INotesDetails[] | undefined;
}
const { charternotelabel, charternotecontent} = styles;
const CharterNotes: FunctionComponent<INotesDetailssProps> = ({ NotesDetailsList, hiringDetailsId, ...props }) => {
  return (
    <>
      <div>
        {NotesDetailsList?.map((note, index) => (
          <GoAContainer key={index}>
            <div>
              <div className={charternotelabel} >{note.createdByDisplayName}</div>
              <div>On {formatDateString(note.createdAt.replace("at", ""))} </div>
              <div className={charternotecontent}>{note.notes}</div>
            </div>
          </GoAContainer>
        ))}
      </div>
    </>
  );
};

export default CharterNotes;
